var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrder = function SvgOrder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.28 0q.355 0 .683.148.32.147.531.416l.008.008 1.144 1.398q.177.216.265.47.089.255.089.533v11.455c0 .434-.151.8-.462 1.11-.31.31-.676.462-1.11.462H1.572c-.434 0-.8-.151-1.11-.462A1.5 1.5 0 0 1 0 14.428V2.973q0-.278.09-.534.085-.252.264-.47L1.499.573l.006-.007q.211-.27.532-.417Q2.365 0 2.72 0zM4.43 4.062H1.308v10.63h13.384V4.062H4.43M5.9 3.416v4.782l.116-.058.267-.133L8 7.147l1.718.86.267.133.116.058V3.416h1.307v6.91L8 8.623l-3.408 1.703v-6.91zM2.598 1.308l-.025.028-.054.065-1.15 1.354h13.263L13.482 1.4l-.055-.065-.025-.028z"
  })));
};
export default SvgOrder;